import { dpsEnvironments } from '../settings/dpsEnvironments';
const config = {
    dpsEnvironmentUrl: dpsEnvironments.prod,
};
/**
 * Analytics Public DPS Service: updateConfig.
 *
 * @param {object} userConfig Object with user specified configuration values.
 * @description
 *
 * You can specify custom configuration options using the `updateConfig` function.
 *
 * ## Configuration Options
 *
 * | Option | Type  | Description |
 * |--|--|--|--|
 * | env | string | The environment can be set to one of the preset environments (`qap1`, `qap2`, `qap3`, `qap4`, `qap5`) or `none` to disable the service. For other environments or to use a mock back-end a full URL to the endpoint may be provided. If no value is specified then the default production environment will be used. |
 * @example
 * // Import the updateConfig function
 * import { updateConfig } from '@octagon/public-analytics-dps-service';
 *
 * // Use a preset environment
 * updateConfig({
 *   env: 'qap1'
 * });
 *
 * // Disable the service during development/testing (suppress all http service calls)
 * updateConfig({
 *   env: 'none'
 * });
 *
 * // Use a custom environment URl
 * updateConfig({
 *   env: 'http://localhost:5000/mock-server-endpoint/'
 * });
 * @category Octagon Public Analytics
 */
export const updateConfig = (userConfig) => {
    // Check if the preset dps environments contain a match for the user specified 'env' key
    // If no match is found then use the value passed in by the user as the dpsEnvironmentUrl
    config.dpsEnvironmentUrl = userConfig.env
        ? dpsEnvironments[userConfig.env] ?? userConfig.env
        : config.dpsEnvironmentUrl;
};
export const getDpsEnvironmentUrl = () => {
    return config.dpsEnvironmentUrl;
};
//# sourceMappingURL=index.js.map